const isEnabled = (value) =>
  value === true ||
  Number(value) === 1 ||
  ['Y', 'YES', 'TRUE', 'DONE', 'COMPLETED'].includes(
    String(value || '').trim().toUpperCase(),
  )

export const getMedicationServiceStatus = (visit = {}) => {
  if (isEnabled(visit.isRxDispensed) || isEnabled(visit.rxDispensed)) return 'done'
  if (isEnabled(visit.isRxOrdered)) return 'waiting'
  return 'none'
}
